// components/ui/lucide-memo.ts
// Auto-generated wrapper for memoized Lucide icons used in this codebase.
import { memo } from 'react';
import * as Lucide from 'lucide-react';
import type { LucideIcon, LucideProps } from 'lucide-react';

const memoIcon = <T extends LucideIcon>(Icon: T): T => memo(Icon) as unknown as T;

export type { LucideIcon, LucideProps };

export const Activity = memoIcon(Lucide.Activity);
export const Receipt = memoIcon(Lucide.Receipt);
export const Cog = memoIcon(Lucide.Cog);
export const AlertCircle = memoIcon(Lucide.AlertCircle);
export const AlertTriangle = memoIcon(Lucide.AlertTriangle);
export const ArrowDown = memoIcon(Lucide.ArrowDown);
export const ArrowLeft = memoIcon(Lucide.ArrowLeft);
export const ArrowRight = memoIcon(Lucide.ArrowRight);
export const ArrowUp = memoIcon(Lucide.ArrowUp);
export const ArrowUpDown = memoIcon(Lucide.ArrowUpDown);
export const ArrowUpRight = memoIcon(Lucide.ArrowUpRight);
export const ArrowUpToLine = memoIcon(Lucide.ArrowUpToLine);
export const AtSign = memoIcon(Lucide.AtSign);
export const Banknote = memoIcon(Lucide.Banknote);
export const Bell = memoIcon(Lucide.Bell);
export const BarChart2 = memoIcon(Lucide.BarChart2);
export const BarChart3 = memoIcon(Lucide.BarChart3);
export const BookOpen = memoIcon(Lucide.BookOpen);
export const Presentation = memoIcon(Lucide.Presentation);
export const Bold = memoIcon(Lucide.Bold);
export const Bot = memoIcon(Lucide.Bot);
export const Box = memoIcon(Lucide.Box);
export const Cpu = memoIcon(Lucide.Cpu);
export const BrainCircuit = memoIcon(Lucide.BrainCircuit);
export const Briefcase = memoIcon(Lucide.Briefcase);
export const Brush = memoIcon(Lucide.Brush);
export const Building = memoIcon(Lucide.Building);
export const Building2 = memoIcon(Lucide.Building2);
export const Calendar = memoIcon(Lucide.Calendar);
export const CalendarDays = memoIcon(Lucide.CalendarDays);
export const Camera = memoIcon(Lucide.Camera);
export const ChartLine = memoIcon(Lucide.ChartLine);
export const Check = memoIcon(Lucide.Check);
export const CheckCircle = memoIcon(Lucide.CheckCircle);
export const CheckCircle2 = memoIcon(Lucide.CheckCircle2);
export const ChevronDown = memoIcon(Lucide.ChevronDown);
export const ChevronLeft = memoIcon(Lucide.ChevronLeft);
export const ChevronRight = memoIcon(Lucide.ChevronRight);
export const ChevronUp = memoIcon(Lucide.ChevronUp);
export const Circle = memoIcon(Lucide.Circle);
export const CircleHelp = memoIcon(Lucide.CircleHelp);
export const CircleX = memoIcon(Lucide.CircleX);
export const Clipboard = memoIcon(Lucide.Clipboard);
export const ClipboardCopy = memoIcon(Lucide.ClipboardCopy);
export const Clock = memoIcon(Lucide.Clock);
export const Clock3 = memoIcon(Lucide.Clock3);
export const Coffee = memoIcon(Lucide.Coffee);
export const Coins = memoIcon(Lucide.Coins);
export const Contrast = memoIcon(Lucide.Contrast);
export const Copy = memoIcon(Lucide.Copy);
export const Power = memoIcon(Lucide.Power);
export const CopyPlus = memoIcon(Lucide.CopyPlus);
export const CreditCard = memoIcon(Lucide.CreditCard);
export const Crop = memoIcon(Lucide.Crop);
export const Crown = memoIcon(Lucide.Crown);
export const Database = memoIcon(Lucide.Database);
export const Diamond = memoIcon(Lucide.Diamond);
export const DollarSign = memoIcon(Lucide.DollarSign);
export const Download = memoIcon(Lucide.Download);
export const Edit = memoIcon(Lucide.Edit);
export const Edit3 = memoIcon(Lucide.Edit3);
export const Eraser = memoIcon(Lucide.Eraser);
export const ExternalLink = memoIcon(Lucide.ExternalLink);
export const Eye = memoIcon(Lucide.Eye);
export const EyeOff = memoIcon(Lucide.EyeOff);
export const FileText = memoIcon(Lucide.FileText);
export const Film = memoIcon(Lucide.Film);
export const Filter = memoIcon(Lucide.Filter);
export const Fingerprint = memoIcon(Lucide.Fingerprint);
export const Folder = memoIcon(Lucide.Folder);
export const Funnel = memoIcon(Lucide.Funnel);
export const Gauge = memoIcon(Lucide.Gauge);
export const Globe = memoIcon(Lucide.Globe);
// Exported as InfinityIcon, not Infinity: the bare name would shadow the JS global
// at every import site.
export const InfinityIcon = memoIcon(Lucide.Infinity);
export const Grid2x2 = memoIcon(Lucide.Grid2x2);
export const GripVertical = memoIcon(Lucide.GripVertical);
export const Handshake = memoIcon(Lucide.Handshake);
export const Hash = memoIcon(Lucide.Hash);
export const Hexagon = memoIcon(Lucide.Hexagon);
export const History = memoIcon(Lucide.History);
export const Image = memoIcon(Lucide.Image);
export const ImageOff = memoIcon(Lucide.ImageOff);
export const ImagePlus = memoIcon(Lucide.ImagePlus);
export const Info = memoIcon(Lucide.Info);
export const Italic = memoIcon(Lucide.Italic);
export const KeyRound = memoIcon(Lucide.KeyRound);
export const Landmark = memoIcon(Lucide.Landmark);
export const Layers = memoIcon(Lucide.Layers);
export const GraduationCap = memoIcon(Lucide.GraduationCap);
export const LayoutGrid = memoIcon(Lucide.LayoutGrid);
export const Link2 = memoIcon(Lucide.Link2);
export const Linkedin = memoIcon(Lucide.Linkedin);
export const List = memoIcon(Lucide.List);
export const ListChecks = memoIcon(Lucide.ListChecks);
export const ListRestart = memoIcon(Lucide.ListRestart);
export const Loader = memoIcon(Lucide.Loader);
export const Loader2 = memoIcon(Lucide.Loader2);
export const LocateFixed = memoIcon(Lucide.LocateFixed);
export const Lock = memoIcon(Lucide.Lock);
export const LogOut = memoIcon(Lucide.LogOut);
export const Mail = memoIcon(Lucide.Mail);
export const Map = memoIcon(Lucide.Map);
export const MapPin = memoIcon(Lucide.MapPin);
export const Maximize2 = memoIcon(Lucide.Maximize2);
export const Menu = memoIcon(Lucide.Menu);
export const Merge = memoIcon(Lucide.Merge);
export const MessageCircle = memoIcon(Lucide.MessageCircle);
export const MessageCircleQuestion = memoIcon(Lucide.MessageCircleQuestion);
export const MessageSquare = memoIcon(Lucide.MessageSquare);
export const Mic = memoIcon(Lucide.Mic);
export const MicOff = memoIcon(Lucide.MicOff);
export const Minimize2 = memoIcon(Lucide.Minimize2);
export const Minus = memoIcon(Lucide.Minus);
export const MoreHorizontal = memoIcon(Lucide.MoreHorizontal);
export const MoreVertical = memoIcon(Lucide.MoreVertical);
export const MousePointer2 = memoIcon(Lucide.MousePointer2);
export const Move = memoIcon(Lucide.Move);
export const PackagePlus = memoIcon(Lucide.PackagePlus);
export const Paintbrush = memoIcon(Lucide.Paintbrush);
export const PanelLeftOpen = memoIcon(Lucide.PanelLeftOpen);
export const PanelRightOpen = memoIcon(Lucide.PanelRightOpen);
export const Paperclip = memoIcon(Lucide.Paperclip);
export const Pause = memoIcon(Lucide.Pause);
export const PenTool = memoIcon(Lucide.PenTool);
export const Pencil = memoIcon(Lucide.Pencil);
export const PencilLine = memoIcon(Lucide.PencilLine);
export const Pentagon = memoIcon(Lucide.Pentagon);
export const Phone = memoIcon(Lucide.Phone);
export const Pin = memoIcon(Lucide.Pin);
export const PinOff = memoIcon(Lucide.PinOff);
export const Pipette = memoIcon(Lucide.Pipette);
export const Play = memoIcon(Lucide.Play);
export const Plus = memoIcon(Lucide.Plus);
export const Pyramid = memoIcon(Lucide.Pyramid);
export const RectangleHorizontal = memoIcon(Lucide.RectangleHorizontal);
export const RectangleVertical = memoIcon(Lucide.RectangleVertical);
export const RefreshCw = memoIcon(Lucide.RefreshCw);
export const Redo2 = memoIcon(Lucide.Redo2);
export const Scale3d = memoIcon(Lucide.Scale3d);
export const Group = memoIcon(Lucide.Group);
export const Ungroup = memoIcon(Lucide.Ungroup);
export const RotateCcw = memoIcon(Lucide.RotateCcw);
export const Undo2 = memoIcon(Lucide.Undo2);
export const Ruler = memoIcon(Lucide.Ruler);
export const Save = memoIcon(Lucide.Save);
export const ScanEye = memoIcon(Lucide.ScanEye);
export const ScanLine = memoIcon(Lucide.ScanLine);
export const Scissors = memoIcon(Lucide.Scissors);
export const SquareSplitHorizontal = memoIcon(Lucide.SquareSplitHorizontal);
export const SquareSplitVertical = memoIcon(Lucide.SquareSplitVertical);
export const RotateCw = memoIcon(Lucide.RotateCw);
export const ArrowLeftRight = memoIcon(Lucide.ArrowLeftRight);
export const Search = memoIcon(Lucide.Search);
export const Send = memoIcon(Lucide.Send);
export const Settings = memoIcon(Lucide.Settings);
export const Shapes = memoIcon(Lucide.Shapes);
export const Share = memoIcon(Lucide.Share);
export const Share2 = memoIcon(Lucide.Share2);
export const Shield = memoIcon(Lucide.Shield);
export const ShieldAlert = memoIcon(Lucide.ShieldAlert);
export const ShieldCheck = memoIcon(Lucide.ShieldCheck);
export const ShoppingCart = memoIcon(Lucide.ShoppingCart);
export const SlidersHorizontal = memoIcon(Lucide.SlidersHorizontal);
export const Sparkle = memoIcon(Lucide.Sparkle);
export const Sparkles = memoIcon(Lucide.Sparkles);
export const Home = memoIcon(Lucide.Home);
export const Split = memoIcon(Lucide.Split);
export const Square = memoIcon(Lucide.Square);
export const SquareDashed = memoIcon(Lucide.SquareDashed);
export const SquarePen = memoIcon(Lucide.SquarePen);
export const Star = memoIcon(Lucide.Star);
export const Store = memoIcon(Lucide.Store);
export const Sun = memoIcon(Lucide.Sun);
export const Tag = memoIcon(Lucide.Tag);
export const Target = memoIcon(Lucide.Target);
export const Gavel = memoIcon(Lucide.Gavel);
export const ThumbsDown = memoIcon(Lucide.ThumbsDown);
export const ThumbsUp = memoIcon(Lucide.ThumbsUp);
export const Trash2 = memoIcon(Lucide.Trash2);
export const TrendingUp = memoIcon(Lucide.TrendingUp);
export const Triangle = memoIcon(Lucide.Triangle);
export const Type = memoIcon(Lucide.Type);
export const Underline = memoIcon(Lucide.Underline);
export const Unlock = memoIcon(Lucide.Unlock);
export const Upload = memoIcon(Lucide.Upload);
export const User = memoIcon(Lucide.User);
export const UserCheck = memoIcon(Lucide.UserCheck);
export const UserMinus = memoIcon(Lucide.UserMinus);
export const UserPlus = memoIcon(Lucide.UserPlus);
export const Users = memoIcon(Lucide.Users);
export const Video = memoIcon(Lucide.Video);
export const Volume2 = memoIcon(Lucide.Volume2);
export const VolumeX = memoIcon(Lucide.VolumeX);
export const Warehouse = memoIcon(Lucide.Warehouse);
export const X = memoIcon(Lucide.X);
export const XCircle = memoIcon(Lucide.XCircle);
export const ZoomIn = memoIcon(Lucide.ZoomIn);
export const ZoomOut = memoIcon(Lucide.ZoomOut);

// Asset Management section additions.
export const Table2 = memoIcon(Lucide.Table2);
export const ALargeSmall = memoIcon(Lucide.ALargeSmall);
export const MoveHorizontal = memoIcon(Lucide.MoveHorizontal);
export const ArrowDownToLine = memoIcon(Lucide.ArrowDownToLine);
export const ArrowUpFromLine = memoIcon(Lucide.ArrowUpFromLine);
export const AlignLeft = memoIcon(Lucide.AlignLeft);
export const AlignCenter = memoIcon(Lucide.AlignCenter);
export const AlignRight = memoIcon(Lucide.AlignRight);
export const Baseline = memoIcon(Lucide.Baseline);
export const Highlighter = memoIcon(Lucide.Highlighter);
export const Palette = memoIcon(Lucide.Palette);
export const Percent = memoIcon(Lucide.Percent);
export const Boxes = memoIcon(Lucide.Boxes);
export const CircleDollarSign = memoIcon(Lucide.CircleDollarSign);
export const Wand2 = memoIcon(Lucide.Wand2);
export const MonitorUp = memoIcon(Lucide.MonitorUp);
export const MonitorOff = memoIcon(Lucide.MonitorOff);
export const AudioLines = memoIcon(Lucide.AudioLines);
export const BookmarkPlus = memoIcon(Lucide.BookmarkPlus);
export const Footprints = memoIcon(Lucide.Footprints);
export const Crosshair = memoIcon(Lucide.Crosshair);
